import { render, staticRenderFns } from "./ReportParcours.vue?vue&type=template&id=505084e7&scoped=true&"
import script from "./ReportParcours.vue?vue&type=script&lang=js&"
export * from "./ReportParcours.vue?vue&type=script&lang=js&"
import style0 from "./ReportParcours.vue?vue&type=style&index=0&id=505084e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505084e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
